module.exports = __webpack_public_path__ + "static/media/JW.1b207aae.png";